import { withInstall } from '@element-plus/utils'
import Countdown from './src/countdown.vue'

export const ElCountdown = withInstall(Countdown)
export default ElCountdown

export * from './src/countdown'
